import PropTypes from 'prop-types'

import { SevenDayRulesStatus } from '../../models/logbook/seven-day-rules-status-enum'
import { iso8601PropType } from '../common/iso-8601-prop-type'

/**
 * @typedef {Object} Logbook7DaysRule
 *
 * @property {number} [logbook7DaysRule] - config for the 7 day rule
 */

export const logbook7DaysRulePropType = PropTypes.shape({
    editableUntil: iso8601PropType.isRequired,
    status: PropTypes.oneOf(Object.values(SevenDayRulesStatus)).isRequired
})
